/*
 *
 *    * Copyright (c)  2018 by INFODATA-GROUP. All rights reserved.
 *    * No part of this publication may be reproduced, distributed,
 *    * or transmitted in any form or by any means, including photocopying, recording,
 *    * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *    * except in the case of brief quotations embodied in critical
 *    * reviews and certain other noncommercial uses permitted by copyright law.
 *    *  author : sid
 *    *  date : 16/08/2022 09:32
 *
 */


import {ComboAction} from './combo-action';
import {DateAction} from './date-action';
import {DropdownAction} from './dropdown-action';
import {ImageAction} from './image-action';
import {InfoAction} from './info-action';
import {MultiAction} from './multi-action';
import {PagingAction} from './paging-action';
import {RadioAction} from './radio-action';
import {SearchAction} from './search-action';
import {SwitchAction} from './switch-action';
import {TableAction} from './table-action';
import {ToggleAction} from './toggle-action';
import {StandardAction} from './standard-action';

export class ActionGenerator {
  generateAction(action: any) {
    const specAction = this.createSpecAction(action);
    this.generateProperties(action, specAction);
    return specAction;
  }

  private createSpecAction(action) {
    switch (action.type) {
      case 'combo':
        return new ComboAction(action.id, action.icon, action.placeholder, null);
      case 'date':
        return new DateAction(action.id, action.label, action.defaultValue, action.icon);
      case 'dropdown':
        return new DropdownAction(action.id, action.icon, null, action.label);
      case 'image-button':
        return new ImageAction(action.id, action.src, action.label);
      case 'info':
        return new InfoAction(action.id, action.label, action.icon);
      case 'multi':
        return new MultiAction(action.id, action.icon, action.label);
      case 'paging':
        return new PagingAction(action.id);
      case 'radio':
        return new RadioAction(action.id, action.icon, null, action.label);
      case 'search':
        return new SearchAction(action.id, action.icon, '', action.url);
      case 'switch':
        return new SwitchAction(action.id, action.icon, '');
      case 'table':
        return new TableAction(action.id, action.icon, '');
      case 'toggle':
        return new ToggleAction(action.id, action.icon, action.label);
      default:
        return new StandardAction(action.id, action.icon, action.label);
    }
  }

  private generateProperties(action: any, specAction: StandardAction) {
    specAction.align = action.align;
    specAction.tooltip = action.tooltip;
    for (const prop in action) {
      if (Object.prototype.hasOwnProperty.call(specAction, prop) && specAction[prop] === undefined) {
        specAction[prop] = action[prop];
      }
    }
  }
}
